import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../Images/logo192.png";
import { getAllMaintenanceScheduleById } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";

DataTable.use(DT);

export default function StatusMaintenanceItems() {
  const [maintenancesItem, setMaintenancesItem] = useState([]);
  const dispatch = useDispatch();
  const { specificMaintenanceSchedule } = useSelector((state) => state.maintenanceSchedule);
  const table = useRef();
  const [loading, setLoading] = useState(true);
  const { ScheduleId } = useParams();

  useEffect(() => {
    dispatch(getAllMaintenanceScheduleById(ScheduleId));
  }, [ScheduleId]);

  useEffect(() => {
    if (specificMaintenanceSchedule) {
      setMaintenancesItem(specificMaintenanceSchedule?.scheduleItems);
      console.log(specificMaintenanceSchedule);
      setLoading(false);
    }
  }, [specificMaintenanceSchedule]);

  function handlePrint() {
    window.print();
  }

  // =========== تحويل الحالة إلى عربي للطباعة =============
  function getStatusText(status) {
    if (status === "pending") return "قيد الانتظار";
    if (status === "completed") return "مكتملة";
    if (status === "InProgress") return "جاري التنفيذ";
    return "غير معروف";
  }

  // =========== أعمدة الجدول في الشاشة ===========
  const screenColumns = [
    {
      title: "اسم العنصر الاساسي",
      data: "standardItem",
      render: (data) => data?.name,
    },
    { title: "الكمية", data: "quantity" },
    { title: "ملاحظات", data: "notes" },
    {
      title: "حالة العنصر",
      data: "status",
      render: (data) => {
        if (data === "pending") {
          return `<span class="text-warning"><i class='fa-solid fa-clock'></i> قيد الانتظار</span>`;
        } else if (data === "completed") {
          return `<span class="text-success"><i class='fa-solid fa-circle-check'></i> مكتملة</span>`;
        } else if (data === "InProgress") {
          return `<span class="text-primary"><i class='fa-solid fa-spinner fa-spin'></i> جاري التنفيذ</span>`;
        } else {
          return `<span class="text-secondary"><i class='fa-solid fa-question-circle'></i> غير معروف</span>`;
        }
      },
    },
    {
      title: "الصورة",
      data: "image",
      render: (a) => (a ? `<a href=${a} target="_blank" rel="noopener noreferrer">اضغط لمشاهدة الصورة</a>` : ""),
    },
  ];

  return (
    <>
      {/* -------- HEADER FOR PRINT -------- */}
      <div className="print-header d-none d-print-block text-center py-3 mb-3">
        <div className="logo d-flex mb-2 align-items-center justify-content-center">
          <figure className="me-3 mb-0">
            <img src={Logo} alt="logo" style={{ height: "70px" }} />
          </figure>
          <div>
            <h1 className="h6 mb-0 text-start">بصمة خبرة لأدوات الأمن والسلامة</h1>
            <h1 className="h6 mb-0 text-start">Experience Mark For Safety & Security Tools</h1>
            <p className="mb-0">Supply ,Installation & Maintenance توريد وتركيب وصيانة</p>
          </div>
        </div>
      </div>

      {/* -------- SCREEN CONTENT -------- */}
      <div className="main">
        <button onClick={handlePrint} className="btn btn-primary d-print-none">
          طباعة
        </button>

        <div className="container-fluid mt-3">
          <div className="table-responsive d-print-none">
            {maintenancesItem?.length > 0 && !loading && (
              <DataTable
                data={maintenancesItem}
                columns={screenColumns}
                className="display table table-striped table-bordered"
                options={{
                  responsive: true,
                  searching: false,
                }}
                ref={table}
              />
            )}
          </div>
        </div>
      </div>

      {/* -------- PRINT TABLE (PLAIN) -------- */}
      <div className="print-title d-none d-block d-print-block text-center mb-3 w-100">
        <h2 className="text-center mx-3" style={{ fontSize: "32px" }}>
          {!specificMaintenanceSchedule?.has_fire_extinguishers && "سند استلام طفايات"}
        </h2>
      </div>

      <div className="print-table d-none d-print-block">
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "8px" }}>اسم العنصر الأساسي</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>الكمية</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>ملاحظات</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>الحالة</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>الصورة</th>
            </tr>
          </thead>

          <tbody>
            {maintenancesItem?.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{item?.standardItem?.name}</td>
                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>{item?.quantity}</td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{item?.notes}</td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{getStatusText(item?.status)}</td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{item?.image ? "Available" : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* -------- PRINT FOOTER -------- */}
      <div className="print-footer d-none d-print-block mt-4">
        <div style={{ padding: "15px", fontSize: "13px" }}>
          <div className="row">
            <div className="col-4">
              <p>
                <input type="checkbox" /> صيانة لمرة واحدة
              </p>
              <p>اسم الفني: ____________________</p>
              <p>التوقيع: ____________________</p>
            </div>

            <div className="col-4">
              <p>
                <input type="checkbox" /> صيانة ضمان
              </p>
              <p>اسم العميل: {specificMaintenanceSchedule?.contractSchedule?.branch?.name}</p>
              <p>التوقيع: ____________________</p>
            </div>

            <div className="col-4">
              <p>
                <input type="checkbox" /> تحت العقد
              </p>
              <p>تليفون: ____________________</p>
            </div>
          </div>

          <p className="mt-3 text-center" style={{ fontWeight: "bold" }}>
            This is not a payment receipt. Customer should request it upon payment
            <br />
            هذا لا يعتبر سند استلام نقدي، يجب على العميل طلب سند رسمي في حال سداد أي مبلغ
          </p>
        </div>
      </div>

      {/* -------- PRINT CSS -------- */}
      <style>
        {`
        @media print {

          .dataTable, .table-responsive, .display {
            display: none !important;
          }

          .print-table {
            display: block !important;
          }

          tr, td, th {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }

          table, tbody {
            page-break-inside: auto !important;
          }

          .print-footer {
            position: static !important;
            margin-top: 25px !important;

            page-break-inside: avoid !important;
            break-inside: avoid !important;

            page-break-before: always !important; 
          }

          .print-header {
            display: block !important;
               margin-bottom: 0 !important;
    padding-bottom: 0 !important;
          }

          .d-print-none {
            display: none !important;
          }
        }

        .print-header {
          display: none;
        }
      `}
      </style>
    </>
  );
}
